export const cloudfrontUrl = "https://d2wsngu38pu7mu.cloudfront.net/brands/ksm";

export const videoUrlsByTiming = {
  // 오전 6시 - 10시 (아침)
  morning: `${cloudfrontUrl}/home/morning_v2.mp4`,
  // 오전 10시 - 오후 22시 (낮)
  day: `${cloudfrontUrl}/home/day_v2.mp4`,
  // 오후 22시 - 자정 24시 (저녁)
  evening: `${cloudfrontUrl}/home/soiree_v2.mp4`,
  // 자정 0시 - 오전 6시 (밤)
  night: `${cloudfrontUrl}/home/minute_v2.mp4`,
};
